// Kontakte-Liste (Runde 5, Agent 5C): Typen und Client nach crm/API.md, Abschnitt 20.3.
import { http } from "./client";
import type { Email, Liste, ListenParameter, Telefon } from "./types";

export interface KontaktZeile {
  id: string;
  lead_id: string;
  lead_name: string | null;
  lead_status_id: string | null;
  lead_status_label: string | null;
  name: string | null;
  /** Funktion, z. B. "Geschäftsführer" */
  title: string | null;
  phones: Telefon[];
  emails: Email[];
  date_created: string | null;
  date_updated: string | null;
}

export type KontakteSortierung = "name" | "-name" | "title" | "-title" | "lead" | "-lead" | "date_created" | "-date_created" | "date_updated" | "-date_updated";

export interface KontakteParameter extends ListenParameter {
  /** Name, Funktion, Lead, Telefon oder E-Mail enthält (jedes Wort) */
  q?: string;
  lead_id?: string;
  /** Lead-Status (mehrere möglich) */
  status_id?: string[];
  /** true: nur mit Telefonnummer, false: nur ohne */
  telefon?: boolean;
  /** true: nur mit E-Mail-Adresse, false: nur ohne */
  email?: boolean;
  sort?: KontakteSortierung;
}

export const kontakteApi = {
  liste: (p: KontakteParameter = {}, signal?: AbortSignal) =>
    http.get<Liste<KontaktZeile>>(
      "/api/kontakte",
      { limit: p.limit, cursor: p.cursor, q: p.q, lead_id: p.lead_id, status_id: p.status_id, telefon: p.telefon, email: p.email, sort: p.sort },
      signal,
    ),
};
